export default "__VITE_ASSET__bFG4ljzp__"